(() => {
  const SELECTOR = '[data-related-products-swiper]';
  const ROOT_SELECTOR = '[data-related-products-root]';

  function initOne(el) {
    if (!el || el.dataset.embeInit === '1') return;
    if (!el.querySelector('.swiper-slide')) return;

    const run = () => {
      if (!window.Swiper) return false;

      const prev = el.querySelector('.related-products__nav--prev');
      const next = el.querySelector('.related-products__nav--next');
      const pagination = el.querySelector('.related-products__pagination');
      const slideCount = el.querySelectorAll('.swiper-slide').length;

      const opts = {
        slidesPerView: 1.2,
        spaceBetween: 10,
        speed: 500,
        roundLengths: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          640: { slidesPerView: 2 },
          1200: { slidesPerView: 3, spaceBetween: 16 },
          1600: { slidesPerView: 4, spaceBetween: 24 }
        }
      };

      if (slideCount <= 1) {
        opts.slidesPerView = 1;
        opts.breakpoints = {};
      }

      if (prev && next && slideCount > 1) {
        opts.navigation = { prevEl: prev, nextEl: next };
      }
      if (pagination && slideCount > 1) {
        opts.pagination = { el: pagination, clickable: true };
      }

      try {
        el.dataset.embeInit = '1';
        // eslint-disable-next-line no-new
        new window.Swiper(el, opts);
      } catch (_) {
        el.classList.add('embe-swiper-failed');
      }

      return true;
    };

    if (run()) return;

    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      if (run()) {
        clearInterval(timer);
        return;
      }
      if (tries >= 30) clearInterval(timer);
    }, 100);
  }

  function initSwipers(root = document) {
    root.querySelectorAll?.(SELECTOR)?.forEach?.(initOne);
  }

  function observeRoots(root = document) {
    root.querySelectorAll?.(ROOT_SELECTOR)?.forEach?.((recommendationsRoot) => {
      if (recommendationsRoot.dataset.relatedProductsObserved === '1') return;
      recommendationsRoot.dataset.relatedProductsObserved = '1';

      const observer = new MutationObserver(() => {
        const swiper = recommendationsRoot.querySelector(SELECTOR);
        if (swiper && swiper.dataset.embeInit !== '1') {
          initOne(swiper);
        }
      });

      observer.observe(recommendationsRoot, { childList: true, subtree: true });
    });
  }

  function init(root = document) {
    observeRoots(root);
    initSwipers(root);
  }

  document.addEventListener('related-products:loaded', (event) => {
    const target = event.target?.closest?.(ROOT_SELECTOR) || event.target;
    if (target) {
      const swiper = target.querySelector?.(SELECTOR);
      if (swiper) initOne(swiper);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
